import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { studentLogout, studentUpdatePassword } from '../../redux/action/studentAction'
import { Link, useHistory } from 'react-router-dom'
import HomeHelper from '../../Components/HomeHelper'
import '../../Style/studentHome.css';
import Footer from '../../Components/Footer';
import Loading from '../../Components/Loading';


const Home = () => {
    const store = useSelector((store) => store);
    const history = useHistory();
    const dispatch = useDispatch();

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    
    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        return passwordRegex.test(password);
    };
    
    const formHandler = (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
    
        // Validation for new password
        if (!validatePassword(newPassword)) {
            setError(
                'Password must be at least 8 characters long, include an uppercase letter, and a lowercase letter.'
            );
            return;
        }
    
        // Check if new password and confirmation match
        if (newPassword !== confirmNewPassword) {
            setError('New password and confirm password do not match.');
            return;
        }
    
        // Dispatch the action if validation passes
        dispatch(
            studentUpdatePassword({
                registrationNumber: store.student.student.student.registrationNumber,
                oldPassword,
                newPassword,
            })
        );
    
        // Set success message
        setMessage('Password updated successfully!');
    };

    const logoutHandler = () => {
        dispatch(studentLogout());
        history.push('/');

    }
    const isStudentDataAvailable = store.student.student.student.name && store.student.student.student.name.length > 0;
    return (
        <div>
            <div>
                {store.student.isAuthenticated ? <>
                    <HomeHelper />
                    <div className='mainHome'>
                        <div className="container-fluid main" style={{ backgroundImage: 'url("/image/pattern.png")', backgroundRepeat: 'repeat' }}>
                            <div className='px-4 py-1 bg-light d-flex align-items-center justify-content-between'>
                                <h3> <img src="logo192.png" width={'50px'} alt="" /> Profile</h3>
                                <button onClick={() => window.print()} type="button" className=" print-helper btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                            </div>
                            <div className='row align-items-center justify-content-center'>
                                <div className="stuData bg-light px-md-5 col-11">
                                    <div className="row">
                                        <div className='sortDetails col-md-3'>
                                            <img className="img-fluid" width={'250px'} src={store.student.student.student.avatar} alt="Card image cap" />
                                            <h5 className='bg-dark text-light p-1 w-100'>{store.student.student.student.name}</h5>
                                            <div className="w-100 print-helper">
                                                <h6 className='d-flex align-items-center'><img src="/image/mail.svg" alt="" className='p-1' />{store.student.student.student.email}</h6>
                                                <h6 className='d-flex align-items-center'><img src="/image/phone.svg" alt="" className='p-1' />{store.student.student.student.studentMobileNumber}</h6>
                                                <h6 className={`badge badge-${store.student.student.student.status === 'active' ? 'success' : store.student.student.student.status === 'irregular' ? 'warning' : 'danger'}`}>{store.student.student.student.status}</h6>
                                                <button onClick={logoutHandler} type="button" className=" btn-danger w-100 btn text-light"> <img src="/image/logout.svg" alt="" /> Logout</button>
                                                <button type="button" className=" btn-info w-100 mt-2 btn text-light" data-bs-toggle="modal" data-bs-target="#exampleModal"> <img src="/image/edit.svg" width={'16px'} alt="" /> Update Password</button>

                                                <div
                                                    className="modal fade"
                                                    id="exampleModal"
                                                    tabIndex="-1"
                                                    aria-labelledby="exampleModalLabel"
                                                    aria-hidden="true"
                                                >
                                                    <div className="modal-dialog">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title fs-5" id="exampleModalLabel">
                                                                    Update Password
                                                                </h5>
                                                            </div>
                                                            <div className="modal-body">
                                                                <form noValidate onSubmit={formHandler}>
                                                                    <div className="mb-3">
                                                                        <label htmlFor="oldPassword" className="form-label">
                                                                            Old Password
                                                                        </label>
                                                                        <input
                                                                            type="password"
                                                                            className="form-control"
                                                                            id="oldPassword"
                                                                            placeholder="Enter your old password"
                                                                            required
                                                                            value={oldPassword}
                                                                            onChange={(e) => setOldPassword(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label htmlFor="newPassword" className="form-label">
                                                                            New Password
                                                                        </label>
                                                                        <input
                                                                            type="password"
                                                                            className="form-control"
                                                                            id="newPassword"
                                                                            placeholder="Enter your new password"
                                                                            required
                                                                            value={newPassword}
                                                                            onChange={(e) => setNewPassword(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label htmlFor="confirmNewPassword" className="form-label">
                                                                            Confirm Password
                                                                        </label>
                                                                        <input
                                                                            type="password"
                                                                            className="form-control"
                                                                            id="confirmNewPassword"
                                                                            placeholder="Enter confirm new password"
                                                                            required
                                                                            value={confirmNewPassword}
                                                                            onChange={(e) => setConfirmNewPassword(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <button type="submit" className="btn btn-success">
                                                                        Update
                                                                    </button>
                                                                </form>
                                                                {error && <div className="alert alert-danger mt-3">{error}</div>}
                                                                {message && <div className="alert alert-success mt-3">{message}</div>}
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                    data-bs-dismiss="modal"
                                                                >
                                                                    Close
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="table-responsive col-md-9">
                                            {isStudentDataAvailable ? (
                                                <table className="table shTable table-striped table-bordered">
                                                    <tbody>
                                                        <tr>
                                                            <td>Name</td>
                                                            <td>{store.student.student.student.name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Email</td>
                                                            <td><small>{store.student.student.student.email}</small></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Registration Number</td>
                                                            <td>{store.student.student.student.registrationNumber}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Date Of Birth</td>
                                                            <td>{store.student.student.student.dob}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Year</td>
                                                            <td>{store.student.student.student.year}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Department</td>
                                                            <td>{store.student.student.student.department}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Section</td>
                                                            <td>{store.student.student.student.section}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Branch</td>
                                                            <td>{store.student.student.student.branch}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Gender</td>
                                                            <td>{store.student.student.student.gender ? store.student.student.student.gender : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Contact Number</td>
                                                            <td>{store.student.student.student.studentMobileNumber ?
                                                                store.student.student.student.studentMobileNumber : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Blood group</td>
                                                            <td>{store.student.student.student.bloodGroup ? store.student.student.student.bloodGroup : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>EMIS Number</td>
                                                            <td>{store.student.student.student.emisNumber ? store.student.student.student.emisNumber : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Religion</td>
                                                            <td>{store.student.student.student.Religion ? store.student.student.student.Religion : "NA"} </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Community</td>
                                                            <td>{store.student.student.student.Community ? store.student.student.student.Community : "NA"} </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Caste</td>
                                                            <td>{store.student.student.student.Caste ? store.student.student.student.Caste : "NA"} </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Aadhar number</td>
                                                            <td>{store.student.student.student.aadharCard ? store.student.student.student.aadharCard : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>First graduate</td>
                                                            <td>{store.student.student.student.FirstGraduate ? store.student.student.student.FirstGraduate : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Special admission</td>
                                                            <td>{store.student.student.student.SpecialAdmission ? store.student.student.student.SpecialAdmission : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Permanent address</td>
                                                            <td ><small>{store.student.student.student.address ? store.student.student.student.address : "NA"}</small></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Fathers name</td>
                                                            <td>{store.student.student.student.fatherName ? store.student.student.student.fatherName : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Fathers occupation</td>
                                                            <td>{store.student.student.student.fatherOccupation ? store.student.student.student.fatherOccupation : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Mother name</td>
                                                            <td>{store.student.student.student.motherName ? store.student.student.student.motherName : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Mother’s occupation</td>
                                                            <td>{store.student.student.student.MotherOccupation ? store.student.student.student.MotherOccupation : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Parent Contact Number</td>
                                                            <td>{store.student.student.student.fatherMobileNumber ? store.student.student.student.fatherMobileNumber : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Annual family income</td>
                                                            <td>{store.student.student.student.AnnualIncome ? store.student.student.student.AnnualIncome : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Bank account number</td>
                                                            <td>{store.student.student.student.BankAccountNumber ? store.student.student.student.BankAccountNumber : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>IFSC code</td>
                                                            <td>{store.student.student.student.IFSCcode ? store.student.student.student.IFSCcode : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Bank name</td>
                                                            <td>{store.student.student.student.BankName ? store.student.student.student.BankName : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Bank branch</td>
                                                            <td>{store.student.student.student.BankBranch ? store.student.student.student.BankBranch : "NA"}</td>
                                                        </tr>

                                                        <tr>
                                                            <td>Academic year of joining</td>
                                                            <td>{store.student.student.student.AcademicYear ? store.student.student.student.AcademicYear : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Date of admission</td>
                                                            <td>{store.student.student.student.DateOfadmission ? store.student.student.student.DateOfadmission : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Type of admission</td>
                                                            <td>{store.student.student.student.TypeOfAdmission ? store.student.student.student.TypeOfAdmission : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Counseling Number</td>
                                                            <td>{store.student.student.student.CounselingNumber ? store.student.student.student.CounselingNumber : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>lateral entry</td>
                                                            <td>{store.student.student.student.lateralEntry ? store.student.student.student.lateralEntry : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Hosteller</td>
                                                            <td>{store.student.student.student.Hosteller ? store.student.student.student.Hosteller : "NA"}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <Loading />

                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2">

                            </div>

                        </div>
                    </div>
                </> : (history.push('/'))}
            </div>
            <Footer />
        </div>

    )
}

export default Home
